import script from "./messageSendBox.vue?vue&type=script&setup=true&lang=js"
export * from "./messageSendBox.vue?vue&type=script&setup=true&lang=js"

import "./messageSendBox.vue?vue&type=style&index=0&id=377e6052&scoped=true&lang=css"

import exportComponent from "/Users/nasinet/hujing_pro/hj_pro_h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-377e6052"]])

export default __exports__